export default __webpack_public_path__ + "static/media/mf_logo_full.7f78c80c.svg";